import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Attach bearer token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("talabya_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // let caller handle
    }
    return Promise.reject(err);
  }
);

export default api;

export function extractError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "حدث خطأ ما";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
